import Bestellung from "@/entities/common/bestellung"
import BaseLogic from "../base_logic"
import IdRequest from "@/entities/common/request/id_request"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import RestPaths from "@/util/rest_paths"

export default class BestellungLogic extends BaseLogic {
  bestellung?: Bestellung = null

  init(id: string) {
    var request = new IdRequest()
    request.id = id

    Poster.postUser<RemoteResult<Bestellung>>(
      RestPaths.bestellungKundeDetails,
      request
    ).then((response) => {
      this.mainLogic.bestellung = new Bestellung()
      this.mainLogic.bestellung = response.data.payload
    })
  }
}
